// extracted by mini-css-extract-plugin
export default {"container":"_1Aqdg","details":"_3F9Hz"};